<template>
  <transition>
    <div v-if="hasUnreadNotifications" class="o-notification-banner">
      <div class="o-container o-container--xlarge notification-banner-inner">
        <div class="notification-banner-message">
          <font-awesome-icon icon="info-circle" />
          {{ $t('components.notificationbanner.message') }}
        </div>
        <div class="notification-banner-cta">
          <bos-button
            color="white-on-red"
            small
            @click.prevent="gotoMessageCenter"
          >
            {{ $t('components.notificationbanner.cta') }}
          </bos-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BosButton from '../components/BosButton'

export default {
  name: 'NotificationBanner',
  data() {
    return {
      notificationDelaLapsed: false,
      notificationDelay: 1.5
    }
  },
  computed: {
    notifications() {
      return [] //this.$store.getters['notifications/get']
    },
    hasUnreadNotifications() {
      return !this.notificationDelaLapsed
        ? false
        : this.notifications.filter(notification => notification.unread)
            .length > 0
    }
  },
  methods: {
    gotoMessageCenter() {
      this.$router.push({ name: 'MessageCenter' })
    }
  },
  created() {
    this.notificationDelaLapsed = false

    this.$store.dispatch('notifications/get')

    setTimeout(() => {
      this.notificationDelaLapsed = true
    }, this.notificationDelay * 1000)
  },
  components: {
    BosButton
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

$notificaton-banner-inner-padding-y: 0.5em !default;
$notificaton-banner-inner-bg: $brand-red !default;
$notificaton-banner-inner-font-size: 1em !default;
$notificaton-banner-inner-font-weight: $font-weight-bold !default;
$notificaton-banner-inner-color: $brand-white !default;

$notification-banner-inner-transition-duration: 450ms !default;

$notification-banner-mobile-inner-cta-margin: 0.5em !default;

.o-notification-banner {
  height: 0;

  .notification-banner-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding-top: $notificaton-banner-inner-padding-y;
    padding-bottom: $notificaton-banner-inner-padding-y;
    background-color: $notificaton-banner-inner-bg;
    font-size: $notificaton-banner-inner-font-size;
    font-weight: $notificaton-banner-inner-font-weight;
    color: $notificaton-banner-inner-color;
  }

  &.v-enter,
  &.v-leave-to {
    .notification-banner-inner {
      transform: translateY(-100%);
    }
  }

  &.v-enter-to,
  &.v-leave {
    .notification-banner-inner {
      transform: translateY(0%);

      &:before {
        display: block;
        content: '';
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        height: 100%;
        background-color: inherit;
      }
    }
  }

  &.v-enter-active {
    transition: $notification-banner-inner-transition-duration;

    .notification-banner-inner {
      animation: bounce-in $notification-banner-inner-transition-duration;
    }
  }

  &.v-leave-active {
    transition: $notification-banner-inner-transition-duration;

    .notification-banner-inner {
      transition: all $notification-banner-inner-transition-duration ease-out;
    }
  }

  .md &,
  .sm &,
  .xs & {
    .notification-banner-inner {
      display: block;

      .notification-banner-cta {
        margin-top: $notification-banner-mobile-inner-cta-margin;
      }
    }
  }

  @keyframes bounce-in {
    0% {
      transform: translateY(-100%);
    }
    60% {
      transform: translateY(10%);
    }
    100% {
      transform: translateY(0%);
    }
  }
}
</style>
